import PropTypes from 'prop-types';

class Comment extends React.Component {
    componentDidMount() {
        let el = ReactDOM.findDOMNode(this);
        el.outerHTML = this.createComment();
    }

    createComment() {
        let text = this.props.text;

        if (this.props.trim) {
            text = text.trim();
        }

        return `<!-- ${text} -->`;
    }

    render() {
        return <div />;
    }
}

Comment.propTypes = {
    text: PropTypes.string,
    trim: PropTypes.bool
};

Comment.defaultProps = {
    trim: true,
    text: ''
};

export default Comment;
